import { z } from "zod"

export const SUPPORT_CATEGORIES = [
  { value: "billing", label: "Billing & subscriptions" },
  { value: "account", label: "Account & login" },
  { value: "technical", label: "Technical issue" },
  { value: "feedback", label: "Feedback & suggestions" },
  { value: "other", label: "Other" },
] as const

export type SupportCategory = (typeof SUPPORT_CATEGORIES)[number]["value"]

const baseFields = {
  category: z.enum(["billing", "account", "technical", "feedback", "other"]),
  subject: z
    .string()
    .trim()
    .min(3, "Subject must be at least 3 characters.")
    .max(200, "Subject must be at most 200 characters."),
  message: z
    .string()
    .trim()
    .min(10, "Please describe your issue in at least 10 characters.")
    .max(8000, "Message is too long."),
}

/** Signed-in users — identity comes from auth. */
export const supportFormSchemaAuthenticated = z.object({
  ...baseFields,
})

/** Guests — require email so support can reply to them. */
export const supportFormSchemaGuest = z.object({
  ...baseFields,
  guestEmail: z.string().trim().email("Enter a valid email address."),
  guestName: z.string().trim().max(120, "Name is too long.").optional(),
})
